export * from './iconFontAwesomeShapesStar';
export * from './iconFontAwesomeShapesHeart';
export * from './iconFontAwesomeShapesCloud';
export * from './iconFontAwesomeShapesComment';
export * from './iconFontAwesomeShapesFile';
export * from './iconFontAwesomeShapesBookmark';
export * from './iconFontAwesomeShapesCircleHalfStroke';
export * from './iconFontAwesomeShapesFolder';
export * from './iconFontAwesomeShapesLocationPin';
export * from './iconFontAwesomeShapesCalendar';
export * from './iconFontAwesomeShapesCircle';
export * from './iconFontAwesomeShapesPlay';
export * from './iconFontAwesomeShapesSquare';
export * from './iconFontAwesomeShapesShield';
export * from './iconFontAwesomeShapesDiamond';
export * from './iconFontAwesomeShapesCrown';
export * from './iconFontAwesomeShapesCertificate';
export * from './iconFontAwesomeShapesTicketSimple';
export * from './iconFontAwesomeShapesShapes';
export * from './iconFontAwesomeShapesLinesLeaning';
export * from './iconFontAwesomeShapesHeartCrack';
export * from './iconFontAwesomeShapesCubesStacked';
export * from './iconFontAwesomeShapesClover';
export * from './iconFontAwesomeShapesBurst';
